import React, { FunctionComponent } from "react";
import Image from "next/image";
import { IList, IListFields } from "@/types/generated/contentful";
import RichText from "../richtext";
import { AssetDetails } from "contentful";

type Props = {
  content: IList;
};

const List: FunctionComponent<Props> = ({ content }) => {
  const {
    customBullet,
    heading,
    headingColor,
    items,
    itemsColor,
    itemsFontSize,
    type,
  } = content.fields as IListFields;

  const listStyle = customBullet ? "list-none" : "list-disc";

  const renderHeading = () => {
    if (heading)
      return (
        <div style={{ color: headingColor }}>
          <RichText content={heading} />
        </div>
      );
    return <></>;
  };

  const itemSize = () => {
    switch (itemsFontSize) {
      case "xs":
        return "text-xs mb-1";
      case "sm":
        return "text-sm mb-1";
      case "base":
        return "text-base";
      case "lg":
        return "text-lg mb-3";
      case "xl":
        return "text-xl mb-4";
      case "2xl":
        return "text-2xl mb-5";
      case "3xl":
        return "text-3xl mb-6";
      case "4xl":
        return "text-4xl mb-7";
      case "5xl":
        return "text-5xl mb-8";
      case "6xl":
        return "text-6xl mb-9";
      case "7xl":
        return "text-7xl mb-10";
      case "8xl":
        return "text-8xl mb-11";
      case "9xl":
        return "text-9xl mb-12";
    }
  };

  const customBulletSize = () => {
    switch (itemsFontSize) {
      case "xs":
        return 12;
      case "sm":
        return 14;
      case "base":
        return 16;
      case "lg":
        return 18;
      case "xl":
        return 20;
      case "2xl":
        return 24;
      case "3xl":
        return 30;
      case "4xl":
        return 36;
      case "5xl":
        return 48;
      case "6xl":
        return 60;
      case "7xl":
        return 72;
      case "8xl":
        return 96;
      case "9xl":
        return 128;
    }
  };

  const renderListItems = () => {
    return items.map((item, index) => {
      return (
        <li
          key={`${content.sys.id}-${index}`}
          className={`flex-inline flex items-start ${itemSize()}`}
          style={{
            color: itemsColor,
          }}
        >
          {customBullet && (
            <Image
              src={customBullet.fields.file?.url as string}
              alt="bullet"
              width={customBulletSize()}
              height={customBulletSize()}
              className="mr-2 flex-none"
            />
          )}
          <span className="-mt-1">{item}</span>
        </li>
      );
    });
  };

  if (type === "ordered")
    return (
      <>
        {renderHeading()}
        <ol className="list-inside list-decimal">{renderListItems()}</ol>
      </>
    );

  return (
    <>
      {renderHeading()}
      <ul className={`list-inside ${listStyle}`}>{renderListItems()}</ul>
    </>
  );
};

export default List;
